import {
  HttpBackend,
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Inject, Injectable, Injector, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, Observable, of, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { SessionService } from "./session.service";
import { TokenService } from "./token.service";

@Injectable({
  providedIn: "root",
})
export class HttpInterceptorsService implements HttpInterceptor {
  private redirectingToLogin = false;
  constructor(private router: Router, private tokenService: TokenService, private sessionService: SessionService) {}
  invalidTokenError(error: HttpErrorResponse): boolean {
    let errorsArray = error.error.errors;
    if (errorsArray === undefined) return false;
    if (
      errorsArray.find((object: any) => object.type === "InvalidTokenError")
    ) {
      return true;
    }
    return false;
  }
  unAuthorizedError(error: HttpErrorResponse): boolean {
    let errorsArray = error.error.errors;
    if (errorsArray === undefined) return false;
    if (
      errorsArray.find((object: any) => object.type === "UnauthorizedError")
    ) {
      return true;
    }
    return false;
  }

  private handleAuthError = (error: any): Observable<never> => {
    if (!this.redirectingToLogin && (this.invalidTokenError(error) || this.unAuthorizedError(error))) {
      this.redirectingToLogin = true;
      this.sessionService.redirectToLogin(this.router.url);
    }
    return throwError(() => error);
  };

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.headers.has("InterceptorSkipHeader")) {
      const headers = request.headers.delete("InterceptorSkipHeader");
      return next.handle(request.clone({ headers })).pipe(catchError(this.handleAuthError));
    }

    if (!this.tokenService.hasToken()) {
      return next.handle(request).pipe(catchError(this.handleAuthError));
    }

    const startSession = sessionStorage.getItem("startSession") === "true" ? "true" : "";
    const uid = localStorage.getItem("userEmail") || "";
    const isBaseApi =
      request.url.startsWith(environment.baseUrl) ||
      request.url.startsWith(environment.baseAPIURl);
    const isAptCheck = !isBaseApi && request.url.includes(environment.aptCheckBaseUrl);

    const setHeaders: Record<string, string> = isAptCheck
      ? {
          Authorization: "Bearer " + this.tokenService.getToken(),
          impersonateFlag: startSession,
          customerId: uid,
        }
      : {
          BearerToken: "Bearer " + this.tokenService.getToken(),
          Authorization:
            "Basic " + btoa(`${environment.sentinentUser}:${environment.sentinentPwd}`),
          impersonateFlag: startSession,
          customerId: uid.toLowerCase(),
        };

    return next.handle(request.clone({ setHeaders })).pipe(catchError(this.handleAuthError));
  }
}
